import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { CONTACT_TYPE_ID, INVOICE_TYPE_ID, CREDIT_MEMO_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { createRetryClient } from './retryClient';
const CRM_SEARCH_URL = 'crm-search/search';
const paidNativeInvoicesQuery = {
  data: {
    sorts: [],
    offset: 0,
    count: 1,
    filterGroups: [{
      filters: [{
        operator: 'EQ',
        property: 'hs_invoice_source',
        value: 'native_invoice'
      }, {
        operator: 'EQ',
        property: 'hs_invoice_status',
        value: 'paid'
      }]
    }],
    objectTypeId: INVOICE_TYPE_ID,
    query: '',
    properties: [],
    portalId: PortalIdParser.get()
  }
};
const finalizedNativeInvoicesQuery = {
  data: {
    sorts: [],
    offset: 0,
    count: 1,
    filterGroups: [{
      filters: [{
        operator: 'EQ',
        property: 'hs_invoice_source',
        value: 'native_invoice'
      }, {
        operator: 'NEQ',
        property: 'hs_invoice_status',
        value: 'draft'
      }]
    }],
    objectTypeId: INVOICE_TYPE_ID,
    query: '',
    properties: [],
    portalId: PortalIdParser.get()
  }
};
const getOpenNativeInvoicesQueryByIdAndAmount = (id, amountBilled) => ({
  data: {
    sorts: [],
    offset: 0,
    count: 1,
    filterGroups: [{
      filters: [{
        operator: 'EQ',
        property: 'hs_invoice_source',
        value: 'native_invoice'
      }, {
        operator: 'EQ',
        property: 'hs_invoice_status',
        value: 'open'
      }, {
        operator: 'EQ',
        property: 'hs_object_id',
        value: id
      }, {
        operator: 'EQ',
        property: 'hs_amount_billed',
        value: amountBilled
      }]
    }],
    objectTypeId: INVOICE_TYPE_ID,
    query: '',
    properties: [],
    portalId: PortalIdParser.get()
  }
});
export const fetchEmailContactOptions = input => http.post(CRM_SEARCH_URL, {
  data: {
    count: 20,
    objectTypeId: CONTACT_TYPE_ID,
    offset: 0,
    portalId: PortalIdParser.get(),
    query: input,
    requestOptions: {
      properties: ['email', 'firstname', 'lastname']
    }
  }
}).then(response => response.results.map(result => ({
  objectId: result.objectId,
  portalId: result.portalId,
  properties: Object.keys(result.properties).reduce((propertiesObject, propertyKey) => Object.assign({}, propertiesObject, {
    [propertyKey]: {
      name: propertyKey,
      value: result.properties[propertyKey].value
    }
  }), {}),
  objectTypeId: result.objectTypeId
})));
export const fetchHasAnyPaidInvoices = async () => {
  try {
    const response = await http.post(CRM_SEARCH_URL, paidNativeInvoicesQuery);
    return response.results.length > 0;
  } catch (error) {
    return false;
  }
};
export const fetchHasAnyFinalizedInvoices = async () => {
  try {
    const response = await http.post(CRM_SEARCH_URL, finalizedNativeInvoicesQuery);
    return response.results.length > 0;
  } catch (error) {
    return false;
  }
};
export const fetchIsOpenInvoiceIndexed = async (id, amountBilled, delay) => {
  const pollingClientForFinalizedIndexedInvoice = createRetryClient({
    failureCondition: response => {
      var _response$responseJSO;
      return (response === null || response === void 0 || (_response$responseJSO = response.responseJSON) === null || _response$responseJSO === void 0 ? void 0 : _response$responseJSO.total) !== 1;
    },
    reason: 'Finalized invoice not yet indexed',
    delay
  });
  return await pollingClientForFinalizedIndexedInvoice.post(CRM_SEARCH_URL, getOpenNativeInvoicesQueryByIdAndAmount(id.toString(), amountBilled));
};
const getAvailableCreditMemosQuery = (contactId, currency) => ({
  data: {
    sorts: [{
      property: 'hs_lastmodifieddate',
      order: 'DESC'
    }, {
      property: 'hs_createdate',
      order: 'DESC'
    }],
    offset: 0,
    count: 100,
    filterGroups: [{
      filters: [{
        operator: 'GT',
        property: 'hs_amount_remaining',
        value: '0'
      }, {
        operator: 'IN',
        property: 'hs_credit_memo_status',
        values: ['unapplied', 'partially_applied']
      }, {
        operator: 'EQ',
        property: 'associations.0-1095',
        value: contactId
      }, {
        operator: 'EQ',
        property: 'hs_currency',
        value: currency
      }]
    }],
    objectTypeId: CREDIT_MEMO_TYPE_ID,
    query: '',
    requestOptions: {
      properties: ['hs_credit_memo_status', 'hs_amount_remaining', 'hs_number', 'hs_currency']
    },
    portalId: PortalIdParser.get()
  }
});
export const fetchAvailableCreditMemos = async (contactId, currency) => {
  if (!contactId || !currency) {
    return [];
  }
  try {
    const response = await http.post(CRM_SEARCH_URL, getAvailableCreditMemosQuery(contactId, currency));
    return response.results.map(result => {
      const properties = Object.keys(result.properties).reduce((propertiesObject, propertyKey) => {
        propertiesObject[propertyKey] = {
          name: propertyKey,
          value: result.properties[propertyKey].value
        };
        return propertiesObject;
      }, {});
      return {
        objectId: result.objectId,
        objectTypeId: result.objectTypeId,
        portalId: result.portalId,
        properties
      };
    });
  } catch (error) {
    return [];
  }
};